import {ChangeDetectionStrategy, Component, input, Input} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MøteRedigerTidspunktKontroller} from "../møte-rediger-tidspunkt/møte-rediger-tidspunkt";
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatIconModule} from "@angular/material/icon";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {TranslateModule} from "@ngx-translate/core";
import {FeltValidatorer} from "felles-ng2/infrastruktur/angular/feltValidatorer";
import {StandardValideringsfeilPipe} from "felles-ng2/pipes/StandardValideringsfeilPipe";
import {RiktekstRedigeringKomponent} from "web-ng2/delt/komponenter/skjema/riktekst-redigering/riktekst-redigering";
import {GruppeId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {nil} from "felles-ng2/typer/nullish";

const debug = initDebugger('MøteRedigerDetaljerKontroller');

type SkjemaType = ReturnType<typeof MøteRedigerDetaljerKontroller.opprettSkjema>;
type SkjemaVerdier = SkjemaType['value'];

export type MøteRedigerDetaljerSkjema = SkjemaType;

@Component({
    selector: 'moete-rediger-detaljer',
    templateUrl: './møte-rediger-detaljer.html',
    styleUrls: ['./møte-rediger-detaljer.scss'],
    imports: [
        MatCheckboxModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatIconModule,
        MøteRedigerTidspunktKontroller,
        TranslateModule,
        StandardValideringsfeilPipe,
        RiktekstRedigeringKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MøteRedigerDetaljerKontroller {

    static opprettSkjema() {
        return new FormGroup({
            tidspunkt: MøteRedigerTidspunktKontroller.opprettSkjema(),

            moetested: new FormControl('', {validators: FeltValidatorer.storStreng}),
            behandlingsmaate: new FormControl('', {validators: FeltValidatorer.litenStreng}),
            formaal: new FormControl('', {validators: FeltValidatorer.htmlTekst})
        })
    }

    skjema = input.required<SkjemaType>();
    fokuserStartdatoFelt = input(false);
    gruppeId = input<GruppeId | nil>(null);

    constructor(private oversettelser: Oversettelser) {
    }

    get stdBehandlingsmaater(): string[] {
        return [
            this.oversettelser.oversett(i18n('Fysisk møte')),
            this.oversettelser.oversett(i18n('Videomøte')),
            this.oversettelser.oversett(i18n('Telefonmøte')),
            this.oversettelser.oversett(i18n('E-postmøte')),
            this.oversettelser.oversett(i18n('Kombinasjon'))
        ];
    }

    // private hjelpemetoder

}
